module.exports = __webpack_public_path__ + "img/Wayne.d0308d0d.png";